export default __webpack_public_path__ + "static/media/estado.f41ddd1b.svg";